export default __webpack_public_path__ + "744fbb0097dda70b2c9016fbd89f053d.svg";